import * as yup from "yup"

export const validationSchema = yup.object().shape({
    religion_code: yup.string().label("Religion code").required().min(2).max(3),
    religion_name: yup.string().label("Religion name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description").optional()
  })